const SITES_PLACEHOLDER = "{{SITES}}";

export type ConsentSite = { trialSiteId: number; name: string };

function dedupeSitesForDisplay(sites: readonly ConsentSite[]): ConsentSite[] {
  const seen = new Set<string>();
  return sites.filter((site) => {
    if (seen.has(site.name)) {
      return false;
    }
    seen.add(site.name);
    return true;
  });
}

type Props = {
  text: string;
  sites: readonly ConsentSite[];
};

export function ConsentBodyText({ text, sites }: Props) {
  const hasMarker = text.includes(SITES_PLACEHOLDER);
  const [before, after = ""] = text.split(SITES_PLACEHOLDER);
  const displaySites = dedupeSitesForDisplay(sites);

  return (
    <>
      <span className="whitespace-pre-line">{before}</span>
      {hasMarker && displaySites.length > 0 && (
        <ul className="list-disc pl-5 py-2">
          {displaySites.map((site) => (
            <li key={site.trialSiteId}>{site.name}</li>
          ))}
        </ul>
      )}
      {after && <span className="whitespace-pre-line">{after}</span>}
    </>
  );
}
